import { countries } from "./countries";

export const getFormattedPhone = (phone: string, countryCode?: string) => {
  if (!countryCode) return phone;

  // Encontrar el código de país
  const phoneCode = countries.find(
    (country) => country.value === countryCode
  )?.phoneCode;

  if (!phoneCode) return phone;

  // 1. Normalizar: eliminar espacios, guiones, paréntesis
  let normalized = phone.replace(/[^\d+]/g, "");

  // 2. Si el número ya empieza con el código de país, devolver tal cual (+598..., +54..., etc.)
  if (normalized.startsWith(`+${phoneCode}`)) {
    return normalized;
  }

  // 3. Si empieza con "+", pero no es el correcto, lo dejamos como está
  if (normalized.startsWith("+")) {
    return normalized;
  }

  // 4. Eliminar ceros iniciales (caso típico: 098111222 → 98111222)
  normalized = normalized.replace(/^0+/, "");

  // 5. Retornar en formato internacional
  return `+${phoneCode}${normalized}`;
};
